import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { TimesheetAndExpensesP58Model } from '../../models/complex/timesheet-and-expenses-p58.model';
import { getUuidV4 } from '../../utilities/generic-utilities';
import { OdataService } from '../odata/odata.service';

@Injectable({
    providedIn: 'root',
})
export class OdataTimesheetService {
    public constructor(private readonly odataService: OdataService) {}

    public saveTimesheet(timesheet: TimesheetAndExpensesP58Model): Observable<unknown> {
        return this.odataService.deepInsertRequest(timesheet, ENDPOINTS.EndOfWorkSet, `${getUuidV4()}`);
    }
}
